import React, { useState, useEffect } from 'react';
import './AddService.css';
import { useDispatch, useSelector } from "react-redux";
import { ShowAllCategories } from "../../../../context/Slice/VendorManagementSlice";
import { UpdateServices } from "../../../../context/Slice/ServiceManagementSlice";
import secureLocalStorage from "react-secure-storage";
import {jwtDecode} from "jwt-decode";

const BASE_URL = process.env.REACT_APP_BASE_URL;

const EditService = ({ handleFormClose, selectedService }) => {
    const dispatch = useDispatch();
    const [formValues, setFormValues] = useState({
        id: selectedService.id || '',
        Vendor_ID:selectedService.Vendor_ID || '',
        ServiceCategory_ID: selectedService.ServiceCategory_ID || '',
        ServiceName: selectedService.ServiceName || '',
        ServiceDescription: selectedService.ServiceDescription || '',
        StartpriceRange: selectedService.StartpriceRange || '',
        EndpriceRange: selectedService.EndpriceRange || '',
        images: selectedService.image ? JSON.parse(selectedService.image) : [],
        video: selectedService.Video ? JSON.parse(selectedService.Video) : null,
        BannerImage: selectedService.BannerImage ? JSON.parse(selectedService.BannerImage) : null,
        City: selectedService.City || '',
        Address: selectedService.Address || ''
    });

    const categories = useSelector((state) => state.VendorManagementR.AllCat);
    const serviceCategories = categories.map(category => ({
        id: category.id,
        name: category.CategorieName,
    }));

    const token = secureLocalStorage.getItem("token");

    useEffect(() => {
        const decoded = jwtDecode(token);
        setFormValues((prevValues) => ({
            ...prevValues,
            id: decoded._id,
        }));
        dispatch(ShowAllCategories());
    }, [dispatch, token]);

    const handleChange = (event) => {
        const { name, value, files } = event.target;
        if (name === 'images') {
            setFormValues({
                ...formValues,
                [name]: Array.from(files).slice(0, 5) // Limit to maximum 5 images
            });
        } else if (name === 'video') {
            setFormValues({
                ...formValues,
                [name]: files[0]
            });
        } else if (name === 'BannerImage') {
            setFormValues({
                ...formValues,
                [name]: files[0]
            });
        } else {
            setFormValues({
                ...formValues,
                [name]: value
            });
        }
    };

    const handleRemoveImage = (index) => {
        const updatedImages = [...formValues.images];
        updatedImages.splice(index, 1);
        setFormValues({
            ...formValues,
            images: updatedImages
        });
    };

    const handleRemoveVideo = () => {
        setFormValues({
            ...formValues,
            video: null
        });
    };

    const handleRemoveBannerImage = () => {
        setFormValues({
            ...formValues,
            BannerImage: null
        });
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
       
        console.log("formValues---------->", formValues);
        try {
            const response = await dispatch(UpdateServices(formValues));
            if (response.status === '200') {
                handleFormClose();
            }
            console.log("response---------->", response);
        } catch (error) {
            console.log("error---------->", error);
        }
    };

    return (
        <div className="add-service-body center">
            <div className="container px-4 mt-4">
                <hr className="mt-0 mb-4" />
                <div className="row justify-content-center">
                    <div className="col-xl-8">
                        <div className="card mb-4">
                            <div className="card-header">Edit Service Details</div>
                            <div className="card-body">
                                <form onSubmit={handleSubmit}>
                                    <div className="row gx-3 mb-3">
                                        <div className="col-md-6">
                                            <label className="small mb-1" htmlFor="ServiceCategory_ID">Service Category</label>
                                            <select
                                                className="form-control"
                                                id="ServiceCategory_ID"
                                                name="ServiceCategory_ID"
                                                value={formValues.ServiceCategory_ID}
                                                onChange={handleChange}
                                            >
                                                <option value="">Select a category</option>
                                                {serviceCategories.map(category => (
                                                    <option key={category.id} value={category.id}>
                                                        {category.name}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                        <div className="col-md-6">
                                            <label className="small mb-1" htmlFor="ServiceName">Service Name</label>
                                            <input
                                                className="form-control"
                                                id="ServiceName"
                                                name="ServiceName"
                                                type="text"
                                                placeholder="Enter service name"
                                                value={formValues.ServiceName}
                                                onChange={handleChange}
                                            />
                                        </div>
                                    </div>
                                    <div className="row gx-3 mb-3">
                                        <div className="col-md-12">
                                            <label className="small mb-1" htmlFor="ServiceDescription">Service Description</label>
                                            <textarea
                                                className="form-control textarea"
                                                id="ServiceDescription"
                                                name="ServiceDescription"
                                                placeholder="Enter service description"
                                                value={formValues.ServiceDescription}
                                                onChange={handleChange}
                                            />
                                        </div>
                                    </div>
                                    <div className="row gx-3 mb-3">
                                        <div className="col-md-6">
                                            <label className="small mb-1" htmlFor="StartpriceRange">Start Price Range</label>
                                            <input
                                                className="form-control"
                                                id="StartpriceRange"
                                                name="StartpriceRange"
                                                type="text"
                                                placeholder="Enter start price range"
                                                value={formValues.StartpriceRange}
                                                onChange={handleChange}
                                            />
                                        </div>
                                        <div className="col-md-6">
                                            <label className="small mb-1" htmlFor="EndpriceRange">End Price Range</label>
                                            <input
                                                className="form-control"
                                                id="EndpriceRange"
                                                name="EndpriceRange"
                                                type="text"
                                                placeholder="Enter end price range"
                                                value={formValues.EndpriceRange}
                                                onChange={handleChange}
                                            />
                                        </div>
                                    </div>
                                    <div className="row gx-3 mb-3">
                                        <div className="col-md-6">
                                            <label className="small mb-1" htmlFor="City">City</label>
                                            <input
                                                className="form-control"
                                                id="City"
                                                name="City"
                                                type="text"
                                                placeholder="Enter City"
                                                value={formValues.City}
                                                onChange={handleChange}
                                            />
                                        </div>
                                        <div className="col-md-6">
                                            <label className="small mb-1" htmlFor="Address">Address</label>
                                            <input
                                                className="form-control"
                                                id="Address"
                                                name="Address"
                                                type="text"
                                                placeholder="Enter Address"
                                                value={formValues.Address}
                                                onChange={handleChange}
                                            />
                                        </div>
                                    </div>
                                    <div className="row gx-3 mb-3">
                                        <div className="col-md-6">
                                            <label className="small mb-1" htmlFor="images">Service Images (Maximum 5)</label>
                                            <input
                                                className="form-control"
                                                id="images"
                                                name="images"
                                                type="file"
                                                multiple
                                                onChange={handleChange}
                                            />
                                            <div className="preview">
                                                {formValues.images.map((image, index) => (
                                                    <div className="image-preview" key={index}>
                                                        <img
                                                            src={image instanceof File ? URL.createObjectURL(image) : `${BASE_URL}/${image.filename}`}
                                                            alt={`Image ${index + 1}`}
                                                        />
                                                        <button
                                                            type="button"
                                                            className="remove-btn"
                                                            onClick={() => handleRemoveImage(index)}
                                                        >
                                                            &times;
                                                        </button>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <label className="small mb-1" htmlFor="video">Service Video (Maximum 1)</label>
                                            <input
                                                className="form-control"
                                                id="video"
                                                name="video"
                                                type="file"
                                                onChange={handleChange}
                                            />
                                            {formValues.video && (
                                                <div className="video-preview">
                                                    <video controls>
                                                        <source
                                                            src={formValues.video instanceof File ? URL.createObjectURL(formValues.video) : `${BASE_URL}/${formValues.video.filename}`}
                                                        />
                                                    </video>
                                                    <button
                                                        type="button"
                                                        className="remove-btn"
                                                        onClick={handleRemoveVideo}
                                                    >
                                                        &times;
                                                    </button>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                    <div className="row gx-3 mb-3">
                                        <div className="col-md-12">
                                            <label className="small mb-1" htmlFor="BannerImage">Banner Image</label>
                                            <input
                                                className="form-control"
                                                id="BannerImage"
                                                name="BannerImage"
                                                type="file"
                                                onChange={handleChange}
                                            />
                                            {formValues.BannerImage && (
                                                <div className="image-preview">
                                                    <img
                                                        src={formValues.BannerImage instanceof File ? URL.createObjectURL(formValues.BannerImage) : `${BASE_URL}/${formValues.BannerImage.filename}`}
                                                        alt="Banner"
                                                    />
                                                    <button
                                                        type="button"
                                                        className="remove-btn"
                                                        onClick={handleRemoveBannerImage}
                                                    >
                                                        &times;
                                                    </button>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                    <div className="row gx-3 mb-3">
                                        <div className="col-md-12">
                                            <button type="submit" className="btn btn-primary">Save Changes</button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default EditService;



